import { SlimPageCard } from '@common/components/layout';
import { Page } from '@customer/components/layout';
import React, { ErrorInfo } from 'react';

export interface ErrorModel {
    error: Error;
    errorInfo: ErrorInfo;
}

export const ErrorView = ({ error, errorInfo }: ErrorModel) => {
    const element = (
        <Page>
            <Page.PageTitle text="An error was encountered" />
            <Page.Content>
                <SlimPageCard>
                    <div>
                        <h2>Something went wrong.</h2>
                        <details style={{ whiteSpace: 'pre-wrap' }}>
                            {error && error.toString()}
                            <br />
                            {process.env['NODE_ENV'] === 'development' && errorInfo.componentStack}
                        </details>
                    </div>
                </SlimPageCard>
            </Page.Content>
        </Page>
    );
    return element;
};
